import gql from 'graphql-tag';

export const DeleteFileMutation = gql`
	mutation DeleteFileMutation($files: [UUID]!) {
		deleteFiles(files: $files) {
			success
		}
	}
`;

export const createFileMutation = gql`
	mutation createFile(
		$file: Upload!
		$name: String
		$isCreationInProgress: Boolean
		$locations: [LocationInput]
	) {
		createFile(
			file: $file
			name: $name
			isCreationInProgress: $isCreationInProgress
			locations: $locations
		) {
			file {
				pk
				file {
					contentType
					name
					url
				}
			}
		}
	}
`;
